export const JIRA_SUMMARY_SEARCH_REQUEST = "JIRA_SUMMARY_SEARCH_REQUEST";
export const JIRA_SUMMARY_SEARCH_RESULT = "JIRA_SUMMARY_SEARCH_RESULT";